module.exports = __webpack_public_path__ + "img/forefoot_strike.ab3b65a4.svg";